import React, { type FC } from 'react'

interface IconDataSyncPromoProps {
  dataAttributeTest?: string
  width?: string | number
  height?: string | number
}

const IconDataSyncPromo: FC<IconDataSyncPromoProps> = (
  { dataAttributeTest, width, height } = {
    width: 265,
    height: 351,
  },
) => {
  return (
    <svg
      width={width}
      height={height}
      data-mu-test={dataAttributeTest}
      viewBox="0 0 265 310"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M160.356 0.67099H31C25.4772 0.67099 21 5.14813 21 10.671V260.2C21 265.723 25.4772 270.2 31 270.2H211C216.523 270.2 221 265.723 221 260.2V68.5667L160.356 0.67099Z"
        fill="#CFEAF1"
      />
      <path
        d="M159.628 0.690857L188.621 34.6631L221.36 68.746L170.666 67.2471C163.49 67.0349 157.844 61.0451 158.056 53.8685L159.628 0.690857Z"
        fill="#83C2D2"
      />
      <g clipPath="url(#clip0_12_258)">
        <path
          d="M107.52 99.7978L107.526 99.7969C108.999 99.5869 110.389 100.778 110.389 102.493V167.188V167.805L110.824 168.243L152.937 210.731C154.152 211.956 153.976 213.842 152.733 214.722L152.722 214.729C142.421 222.153 129.809 226.5 116.195 226.5C81.3798 226.5 53.1113 198.026 53.1113 162.844C53.1113 130.661 76.8049 104.039 107.52 99.7978Z"
          fill="#1286A4"
          stroke="#043954"
          strokeWidth="3"
        />
        <path
          d="M172.891 209.198L172.891 209.198L172.882 209.189L132.712 168.688H193.264C194.908 168.688 196.119 170.054 195.921 171.605C193.896 186.43 186.825 199.61 176.493 209.343C175.504 210.274 173.91 210.243 172.891 209.198ZM184.922 152.656H126.306V93.5066C126.306 91.8061 127.601 90.5 129.111 90.5C161.558 90.5 187.889 117.046 187.889 149.812C187.889 151.369 186.575 152.656 184.922 152.656Z"
          fill="white"
          stroke="#043954"
          strokeWidth="3"
        />
      </g>
      <rect
        x="1.5"
        y="22.5"
        width="76"
        height="76"
        rx="8.5"
        fill="#83C2D2"
        stroke="#043954"
        strokeWidth="3"
      />
      <g clipPath="url(#clip1_12_258)">
        <path
          d="M51.1619 76.6431H50.7191C45.3177 76.414 40.9909 71.9254 40.9909 66.3963C40.9909 60.7201 45.5512 56.1404 51.1528 56.1404C56.7544 56.1404 61.3147 60.7201 61.3147 66.3963C61.3147 68.5338 60.6698 70.5194 59.5593 72.1586L58.8672 73.1802L59.7363 74.0563L66.9429 81.3211L66.9486 81.3268C67.2072 81.5846 67.2222 82.0372 66.9373 82.3275C66.6811 82.5886 66.257 82.5968 65.9842 82.3218L58.7775 75.057L57.8976 74.17L56.8662 74.875C55.2365 75.9889 53.279 76.6431 51.1619 76.6431ZM37.9348 56.0004C36.0282 57.9224 33.4447 59 30.7535 59C28.0623 59 25.4789 57.9224 23.5722 56.0004C21.6652 54.0779 20.5916 51.468 20.5916 48.7441C20.5916 46.0201 21.6652 43.4102 23.5722 41.4877C25.4789 39.5657 28.0623 38.4881 30.7535 38.4881C33.4447 38.4881 36.0282 39.5657 37.9348 41.4877C39.8419 43.4102 40.9155 46.0201 40.9155 48.7441C40.9155 51.468 39.8419 54.0779 37.9348 56.0004ZM11.8452 81.2842C11.8452 73.0546 18.4554 66.4085 26.5899 66.4085H34.9172C34.9731 66.4085 35.0289 66.4088 35.0845 66.4093C35.0999 74.5668 41.1016 81.3201 48.9203 82.417C48.7766 82.4783 48.6195 82.5119 48.456 82.5119H13.0511C12.3967 82.5119 11.8452 81.9733 11.8452 81.2842ZM54.5291 58.2148C53.4619 57.7692 52.3177 57.5397 51.1619 57.5397C48.8271 57.5397 46.5903 58.4748 44.9431 60.1353C43.2962 61.7955 42.3732 64.0445 42.3732 66.3872C42.3732 68.7298 43.2962 70.9789 44.9431 72.639C46.5903 74.2995 48.8271 75.2346 51.1619 75.2346C52.3177 75.2346 53.4619 75.0051 54.5291 74.5595C55.5963 74.1139 56.5651 73.4611 57.3807 72.639C58.1962 71.8169 58.8425 70.8416 59.2832 69.769C59.7239 68.6965 59.9506 67.5474 59.9506 66.3872C59.9506 65.227 59.7239 64.0778 59.2832 63.0053C58.8425 61.9328 58.1962 60.9574 57.3807 60.1353C56.5651 59.3132 55.5963 58.6604 54.5291 58.2148Z"
          fill="#1286A4"
          stroke="black"
          strokeWidth="3"
        />
      </g>
      <path
        d="M58.3096 77.1763L49.3751 79.9977L41.8513 75.2953L38.0894 67.3013L39.5001 61.1882L43.262 56.0156L49.3751 53.6644L59.2501 55.5453L63.012 62.5989L63.9524 70.1227L62.5417 73.4144L70.0655 82.3489L66.3036 85.1703L58.3096 77.1763Z"
        fill="#83C2D2"
      />
      <g clipPath="url(#clip2_12_258)">
        <circle cx="51.4044" cy="66.9931" r="10.2808" fill="#FFC400" />
        <path
          d="M63.1897 66.5293C63.1897 69.143 62.3413 71.5574 60.912 73.5162L68.121 80.7309C68.8327 81.4426 68.8327 82.5986 68.121 83.3104C67.4092 84.0222 66.2532 84.0222 65.5414 83.3104L58.3325 76.0957C56.3736 77.5307 53.9593 78.3734 51.3456 78.3734C44.8028 78.3734 39.5015 73.072 39.5015 66.5293C39.5015 59.9866 44.8028 54.6852 51.3456 54.6852C57.8883 54.6852 63.1897 59.9866 63.1897 66.5293ZM51.3456 74.7291C52.4224 74.7291 53.4887 74.517 54.4835 74.1049C55.4783 73.6928 56.3823 73.0888 57.1437 72.3274C57.9051 71.566 58.5091 70.6621 58.9212 69.6672C59.3333 68.6724 59.5454 67.6061 59.5454 66.5293C59.5454 65.4525 59.3333 64.3862 58.9212 63.3914C58.5091 62.3965 57.9051 61.4926 57.1437 60.7312C56.3823 59.9698 55.4783 59.3658 54.4835 58.9537C53.4887 58.5416 52.4224 58.3295 51.3456 58.3295C50.2688 58.3295 49.2025 58.5416 48.2077 58.9537C47.2128 59.3658 46.3089 59.9698 45.5475 60.7312C44.786 61.4926 44.1821 62.3965 43.77 63.3914C43.3579 64.3862 43.1458 65.4525 43.1458 66.5293C43.1458 67.6061 43.3579 68.6724 43.77 69.6672C44.1821 70.6621 44.786 71.566 45.5475 72.3274C46.3089 73.0888 47.2128 73.6928 48.2077 74.1049C49.2025 74.517 50.2688 74.7291 51.3456 74.7291Z"
          fill="#043954"
        />
      </g>
      <rect x="192" y="237" width="50" height="46" rx="6" fill="white" />
      <g clipPath="url(#clip3_12_258)">
        <path
          d="M208.357 234.454V235.954H209.857H224.143H225.643V234.454V230.891C225.643 229.753 226.564 228.829 227.714 228.829C228.865 228.829 229.786 229.753 229.786 230.891V234.454V235.954H231.286H236.643C238.776 235.954 240.5 237.679 240.5 239.798V243.641H193.5V239.798C193.5 237.679 195.224 235.954 197.357 235.954H202.714H204.214V234.454V230.891C204.214 229.753 205.135 228.829 206.286 228.829C207.436 228.829 208.357 229.753 208.357 230.891V234.454ZM214.613 254.582L214.61 254.589L214.607 254.596L212.322 259.212L207.226 259.955C207.225 259.955 207.223 259.955 207.222 259.955C205.036 260.266 204.176 262.949 205.737 264.481L205.743 264.486L209.439 268.077L208.57 273.135C208.57 273.137 208.569 273.138 208.569 273.14C208.185 275.331 210.496 276.964 212.429 275.949L217 273.554L221.571 275.949C223.529 276.977 225.789 275.306 225.433 273.152L225.431 273.142L224.561 268.077L228.254 264.49C228.255 264.489 228.255 264.488 228.256 264.488C229.848 262.948 228.964 260.264 226.777 259.955C226.775 259.955 226.773 259.954 226.772 259.954L221.678 259.212L219.393 254.596L218.98 253.761H218.745C217.504 252.677 215.431 252.973 214.613 254.582ZM193.5 250.204H240.5V278.985C240.5 281.103 238.776 282.829 236.643 282.829H197.357C195.224 282.829 193.5 281.103 193.5 278.985V250.204Z"
          fill="#FFC400"
          stroke="#043954"
          strokeWidth="3"
        />
      </g>
      <defs>
        <clipPath id="clip0_12_258">
          <rect
            width="155"
            height="139"
            fill="white"
            transform="translate(43 89)"
          />
        </clipPath>
        <clipPath id="clip1_12_258">
          <rect
            width="58.3095"
            height="47.0238"
            fill="white"
            transform="translate(10.3452 36.9881)"
          />
        </clipPath>
        <clipPath id="clip2_12_258">
          <rect
            width="29.1548"
            height="29.1548"
            fill="white"
            transform="matrix(-1 0 0 1 68.6548 54.6852)"
          />
        </clipPath>
        <clipPath id="clip3_12_258">
          <rect
            width="50"
            height="57"
            fill="white"
            transform="translate(192 227.329)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default IconDataSyncPromo
